import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { Container, Col, Input, FormGroup } from 'reactstrap';
import classNames from 'classnames';
import styles from './Login.module.css';
import { SessionContext } from '../context/SessionContext';
import { ReactComponent as ShieldBackground } from '../assets/images/forgot-password.svg';
import { DropDownAutoComplete } from '../components/inputs/DropDownAutoComplete';
import SpinnerButton from '../components/shared/SpinnerButton/SpinnerButton';

let loginContainer = styles.loginContainer;

const VerifyEmail = (props) => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;
    const accountNameToLower = accountName.toLowerCase();
    const [isSendEmailInProgress, setIsSendEmailInProgress] = useState(false);

    const [formData, setFormData] = useState({
        verifyEmail: {}
    });
    const [emailOptions, setEmailOptions] = useState([]);
    const [emailId, setEmailId] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        const emails = [];
        props?.location?.state?.emails.map((email) => {
            emails.push({
                data: email.partyEmailId,
                display: email.address
            });
        });
        setEmailOptions(emails);
    }, []);

    const handleDropdownChange = (val) => {
        setEmailId(val);
    };

    const handleEmail = (e) => {
        e.preventDefault();
        setIsSendEmailInProgress(true);
        const route = '/authentication/SendVerificationCode';
        const model = {
            partyEmailId: emailId
        };
        fetch(route, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        }).then((response) => {
            setIsSendEmailInProgress(false);
            if (response.status === 200) {
                if (response.ok === true) {
                    setError(false);
                    props.history.push({
                        pathname: '/verifylogin',
                        state: {
                            verifyEmailStatus: true,
                            emailId: emailId,
                            dealerInfo: props?.location?.state?.dealerInfo
                        }
                    });
                    return true;
                } else {
                    setError(true);
                }
            } else if (response.status === 404) {
                setError(true);
            } else {
                setError(true);
            }
        });
    };

    const handleRedirect = (e) => {
        e.preventDefault();
        sessionContext.setLoginByEmailStatus(false);
        return <Redirect to='/login' />;
    };

    if (!sessionContext.loginByEmailStatus) {
        return <Redirect to='/login' />;
    }

    return (
        <div className={styles.vendorForgotPass}>
            <ShieldBackground className={styles.shieldBackground} />
            <Container className={styles.mainContainer}>
                <Col
                    md='12'
                    lg='12'
                >
                    <Col
                        lg='6'
                        md='12'
                        xs='12'
                        className={classNames(loginContainer, 'p-0', 'mb-0')}
                    >
                        <h1 className='h3 mb-1'>Verify It's You</h1>
                    </Col>
                    <Col
                        lg='5'
                        md='8'
                        xs='12'
                        className={classNames('p-0', 'pb-3', styles.infoText)}
                    >
                        <p className='mb-0'>
                            To help keep your account secure, please select your preferred
                            <br />
                            verification email address to receive a one-time passcode.
                        </p>
                    </Col>
                    <Col
                        lg='4'
                        md='5'
                        className={classNames(loginContainer, 'p-0', 'pb-3')}
                    >
                        <FormGroup>
                            <label
                                for='dealerId'
                                className='form-label'
                            >
                                Verification Email
                            </label>
                            <span
                                aria-hidden='true'
                                className='required-indicator'
                            >
                                *
                            </span>
                            <DropDownAutoComplete
                                name='verifyEmail'
                                id='verifyEmail'
                                aria-required='true'
                                value={formData.verifyEmail.data}
                                options={emailOptions}
                                onChangedValue={handleDropdownChange}
                            />
                        </FormGroup>
                        <SpinnerButton
                            type='primary'
                            spinning={isSendEmailInProgress}
                            disabled={emailId === '' || isSendEmailInProgress}
                            onClick={handleEmail}
                            text='Continue'
                        />
                        <Col
                            md='12'
                            className={styles.enrollNow}
                        >
                            <a
                                href=''
                                onclick={handleRedirect}
                            >
                                Back to Login
                            </a>
                        </Col>
                    </Col>
                </Col>
            </Container>
        </div>
    );
};

export default VerifyEmail;
